import script from "./LearnersRolloverTableComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LearnersRolloverTableComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__